export default {
  production: false,
  API_ENDPOINT: `https://pocstrapiionic.herokuapp.com`,
  ONESIGNAL_APP_ID: 'c3e9cde1-fbe1-4971-bbce-4bf9fd459832',
  ONESIGNAL_GOOGLE_SENDER_ID: '344964455026',
  STRIPE_API_KEY:
    'pk_live_51JQKJuGc5f5SjlzfaGln9JN4FdniAxnYtbE9fAJyaygMecmqsFXREXLQ0DYmSC459dmV0q8DRf3LuipniZVKmgWa00pIE7phqz',
};
